<template>
  <v-dialog v-model="dialog" persistent max-width="800" scrollable>
    <v-card flat tile color="white">
      <v-card-title class="dialog-header-title">{{ title }}</v-card-title>
      <v-card-text class="py-0" style="height: 450px">
        <v-row no-gutters v-if="fileList.length > 0">
          <v-col>
            <!-- <v-divider></v-divider> -->
            <v-row
              v-for="(item, index) in fileList"
              :key="index"
              class="px-3"
              :style="{ backgroundColor: getRowBackgroundColor(item) }"
            >
              <v-col>
                <v-row no-gutters>
                  <v-col>
                    <div style="font-size: 14px">
                      {{ index + 1 }})
                      <b>{{ item.file_tags[0] }}:</b>
                      {{ item.file_name }}
                    </div>
                  </v-col>

                  <v-col cols="4" lg="2" class="d-flex justify-end">
                    <v-btn
                      small
                      icon
                      class="mx-1"
                      style="
                        height: 24px;
                        width: 24px;
                        border-left-radius: 50%;
                        border-right-radius: 50%;
                      "
                      @click="selectedFile = item"
                      v-if="!manageFiles"
                    >
                      <v-icon color="green darken-1">fa-hand-pointer</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      icon
                      class="mx-1"
                      style="
                        height: 24px;
                        width: 24px;
                        border-left-radius: 50%;
                        border-right-radius: 50%;
                      "
                      @click="onViewFile(item)"
                    >
                      <v-icon color="primary">mdi-eye</v-icon>
                    </v-btn>
                    <v-btn
                      small
                      icon
                      class="ml-1"
                      style="
                        height: 24px;
                        width: 24px;
                        border-left-radius: 50%;
                        border-right-radius: 50%;
                      "
                      v-if="manageFiles"
                      @click="onFileDelete(item)"
                    >
                      <v-icon color="error">mdi-delete-forever</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row v-else>
          <v-col>
            <v-alert tile style="z-index: 1" type="info" class="my-10"
              >No files saved yet for this company</v-alert
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="py-0 my-0"></v-divider>
      <v-card-actions>
        <v-row justify="end">
          <v-btn
            class="font-weight-bold mr-2"
            small
            tile
            depressed
            color="primary"
            @click="onSelect"
            :disabled="selectedFile == null"
            >SELECT FILE</v-btn
          >

          <v-btn
            class="font-weight-bold ml-2"
            small
            tile
            depressed
            color="error"
            @click="onClose"
            >CLOSE</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "../../const";

export default {
  props: ["dialog", "company", "title", "manageFiles"],

  data() {
    return {
      selectedFile: null,
      fileList: [],
    };
  },

  watch: {
    dialog: function () {
      if (this.dialog) {
        this.selectedFile = null;
        this.fileList = [];
        this.initializeFilesList();
      }
    },
  },

  methods: {
    async initializeFilesList() {
      this.$root.blockUImsg = "Loading";
      this.$root.blockUIshow = true;

      let resp = await this.$https.get(
        `/api/files/list?category=quotations&company_id=${this.company.company_id}`
      );
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.fileList = resp.data.data;
      } else {
        this.fileList = [];
      }
      this.$root.blockUIshow = false;
    },

    onSelect() {
      this.$emit("dialog-file-list-close", this.selectedFile);
    },

    onClose() {
      this.$emit("dialog-file-list-close", null);
    },

    async onViewFile(item) {
      this.$root.blockUIshow = true;
      let resp = await this.$https.get(`/api/files/${item.file_id}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        window.open(resp.data.data);
      } else {
        console.log(resp.data);
      }
      this.$root.blockUIshow = false;
    },

    async onFileDelete(item) {
      this.$root.blockUIshow = true;
      let resp = await this.$https.delete(`/api/files/${item.file_id}`);
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        this.initializeFilesList();
      }
      this.$root.blockUIshow = false;
    },

    getRowBackgroundColor: function (item) {
      var color = "transparent";

      if (this.selectedFile != null && this.selectedFile == item) {
        color = "#80CBC4";
      }

      return color;
    },
  },
};
</script>

<style>
.sub-heading {
  font-weight: normal;
  font-size: 120%;
}
</style>
